import { useCallback, useContext } from 'react';
import { decamelizeKeys } from 'humps';
import { IRequestOptions } from '../utils/request';
import { FlexContext } from '../contexts/flexContext';
import useHttpCall, { IHttpCall } from './useHttpCall';

export type IFlexHttpCall = IHttpCall;

export interface IFlexHttpCallOptions extends IRequestOptions {
  memoryOverride?: object;
}

const useFlexHttpCall = () => {
  const handleHttpCall = useHttpCall();
  const flexContext = useContext(FlexContext);

  const handleFlexHttpCall = useCallback(
    <T>(call: IFlexHttpCall, options?: IFlexHttpCallOptions): Promise<T> => {
      const { memoryOverride, ...restOptions } = options ?? {};
      const memory =
        memoryOverride !== undefined
          ? memoryOverride
          : flexContext.node?.memory;
      return handleHttpCall<T>(call, {
        ...restOptions,
        body: {
          ...restOptions?.body,
          ...(typeof memory === 'object' && {
            ...decamelizeKeys(memory),
          }),
        },
      });
    },
    [handleHttpCall, flexContext.node]
  );

  return handleFlexHttpCall;
};

export default useFlexHttpCall;
